export default {
  baseStyle: {
    container: {
      borderRadius: 4
    }
  }
}
